/**
 * ShopByBrand  Functional Component
 * @Package - seo/Part
 * @Author - Cybage@UPWA-Team
 * @description: ShopByBrand related to Part SEO
 */
/**
 *  Part SEO's ShopByBrand Component
 */
import React, { useMemo } from 'react'
import SeoShopByBrand from '../../SeoShopByBrand'

export default function ShopByBrand({ dynamicApiData }) {
  const brands = useMemo(
    () => dynamicApiData && dynamicApiData.shopByBrands,
    [dynamicApiData],
  )
  const hasBrands = useMemo(
    () => Boolean(brands && Object.keys(brands).length),
    [brands],
  )

  const data = useMemo(
    () => brands || [],
    [brands],
  )
  const title = useMemo(
    () => (dynamicApiData && dynamicApiData.headings && dynamicApiData.headings.shopByBrands)|| '',
    [dynamicApiData],
  )

  if (!hasBrands) return ''

  return (
    <SeoShopByBrand
      id="PartShopByBrand"
      data={data}
      title={title}
    />
  )
}
